import React, { useEffect } from 'react';
import { FormModal, FormField } from '../../../components/ui/Modal';
import { useAddCategoryModal } from './AddCategoryModal.hooks';

interface AddCategoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: { nombre: string; descripcion: string }) => Promise<void>;
}

const AddCategoryModal: React.FC<AddCategoryModalProps> = ({ isOpen, onClose, onSave }) => {
  const {
    formData,
    loading,
    error,
    isFormValid,
    handleFormChange,
    handleSave,
    handleClose,
    resetForm,
  } = useAddCategoryModal();

  // Resetear formulario cuando el modal se abre
  useEffect(() => {
    if (isOpen) {
      resetForm();
    }
  }, [isOpen, resetForm]);

  const fields: FormField[] = [
    {
      name: 'nombre',
      label: 'Nombre',
      type: 'text',
      placeholder: 'Ej. Anillos',
      required: true,
    },
    {
      name: 'descripcion',
      label: 'Descripción',
      type: 'textarea',
      placeholder: 'Descripción del tipo de producto...',
      rows: 3,
    },
  ];

  const handleSaveClick = async () => {
    await handleSave(onSave);
  };

  // Convert formData to Record<string, string> for FormModal
  const formDataRecord: Record<string, string> = {
    nombre: formData.nombre || '',
    descripcion: formData.descripcion || '',
  };

  return (
    <FormModal
      open={isOpen}
      onClose={() => handleClose(onClose)}
      title="Agregar Tipo de Producto"
      fields={fields}
      formData={formDataRecord}
      onFieldChange={handleFormChange}
      onSave={handleSaveClick}
      loading={loading}
      error={error}
      isFormValid={isFormValid}
      saveButtonText="Guardar"
      cancelButtonText="Cancelar"
      maxWidth="sm"
      variant="simple"
    />
  );
};

export default AddCategoryModal;
